<p>{{title|translate}}</p>
<div style="text-align: right">
  <button mat-button color="primary" (click)="confirmClicked()">{{confirm_text|translate}}</button>
  <button mat-button style="color: gray" (click)="onClose()" *ngIf="is_show_cancel">{{'cancel'|translate}}</button>
</div>
